import React, { useContext } from 'react'
import mainContext from '../../../contexts/mainContext'
import { __constants, __snackBarText, __snackBarSeverity } from '../../../constants';
import { styled } from '@mui/system';
import { Divider } from '@mui/material';
import FullChat from './FullChat';
import { getChatUsers } from '../../../Controllers/ChatLogs';
import moment from 'moment';
import SearhcBar from './SearchBar';


export default function ChatLogs() {
  const { setProfileNavTitle, setPageload } = useContext(mainContext);
  const [state, setState] = React.useState({ users: [], total: 0, page: 1 })
  const [viewChatState, setViewChatState] = React.useState({ open: false, data: {} })
  const [filterState, setFilterState] = React.useState({});

  React.useEffect(() => {
    setProfileNavTitle("Chat-log users");
    fetchUsersList(state.page)
    // eslint-disable-next-line
  }, [])

  const fetchUsersList = async (page, isClear) => {
    let params = { page }
    if (!isClear)
      params = { page, ...filterState }
    setPageload(true)
    const res = await getChatUsers(params)
    setPageload(false)
    if (res.data.status === 200) {
      let formatResponse = []
      res.data.data.users.forEach((object) => {
        object.userInfo.forEach((user) => {
          if (user.role === "Seeker") {
            object.seeker = user
          } else {
            object.provider = user
          }
        })
        object.userInfo = undefined
        formatResponse.push(object)
      })
      setState({ ...state, users: formatResponse, total: res.data.data.total })
    }
  }

  return (
    <>
      <SearhcBar filterState={filterState} setFilterState={setFilterState} callFunction={fetchUsersList} />
      <Container className='scrollbar'>
        <Body>
          <>
            <Divider className='divider-gap' />
            <List>
              <div className="header">Customer</div>
              <div className="header">Customers’ email</div>
              <div className="header">Provider / Role</div>
              <div className="header">Providers’ email</div>
              <div className="header">City</div>
              <div className="header">Activity</div>
              <div className="header">Last Chat</div>
              <div className="header">View</div>
            </List>
            <Divider className='divider-gap' />
            {state.users.map((object) =>
              <List key={object._id}>
                <div>{`${object.seeker?.firstName || ''} ${object.seeker?.lastName || ''}`}</div>
                <div>{object.seeker?.email || '-'}</div>
                <div>{`${object.provider?.firstName || '-'} ${object.provider?.lastName || ''} / ${object.provider?.role || '-'}`}</div>
                <div>{object.provider?.email || '-'}</div>
                <div>{object.provider?.city || '-'}</div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {object.illegalActivityCount === 0 ?
                    <>
                      <div className='legal-dot'></div>
                      legal
                    </>
                    :
                    <>
                      <div className='illegal-dot'></div>
                      ({object.illegalActivityCount}) Illegal
                    </>
                  }
                </div>
                <div>{object.updatedAt ? moment(object.updatedAt).format("ddd, MM/DD/YYYY") : '-'}</div>
                <button className="list_card_view_btn" onClick={() => setViewChatState({ ...viewChatState, open: true, data: object })}>Chat logs</button>
              </List>)}
          </>
          {state.users.length === 0 && <div className='no-record'><span>No Record Found</span></div>}
        </Body>
      </Container>

      {/* Show FullChat in Canvas */}
      <FullChat
        data={viewChatState.data}
        open={viewChatState.open}
        handleClose={() => setViewChatState({ ...viewChatState, open: false })} />
    </>
  )
}

const Container = styled("div")`
  .divider-gap{
        margin: 0.5rem 0;
  }
  button{
    text-transform: none;
  }
  overflow-x: auto;
  margin-bottom:10px;
`;

const Body = styled("div")`
  height: 80vh;
  margin-bottom:10px;
  min-width:1300px;
`;

const List = styled("div")`
.header{
    font-family: "semi-bold";
}
div{
  overflow: auto;
  word-break: break-all;
}
  .illegal-dot{
    width:10px;
    height:10px;
    border-radius:100%;
    background-color:red;
    margin-right:5px;
  }
  .legal-dot{
    width:10px;
    height:10px;
    border-radius:100%;
    background-color:green;
    margin-right:5px;
  }
  margin-top: 1rem;
  display: grid;
  column-gap: 0.7rem;
  grid-template-columns: minmax(0,1.3fr) minmax(0,2.3fr) minmax(0,2.8fr) minmax(0,2.3fr) minmax(0,0.9fr) minmax(0,0.9fr) minmax(0,1.3fr) minmax(0,0.9fr);
  align-items: center;
  grid-auto-flow: column;
  font-size:14px;
`;
